import {getPMSBaseUrl} from '../../../services/apiService'
import {createFetchActions} from '../../../services/createActions'
import {post} from '../../../services/createAPICall'
export const ROLL_MATURING_TRADES = createFetchActions('ROLL_MATURING_TRADES')

export const rollMaturingTrades = (data: any) => (dispatch: any) => {
	return dispatch(post(ROLL_MATURING_TRADES, `${getPMSBaseUrl()}/v1/portfolios/roll`, data))
}
